/* eslint-disable camelcase */
/* eslint-disable @typescript-eslint/camelcase */
import 'babel-polyfill'
import 'custom-event-polyfill'
import * as i18next from 'i18next'
import 'lazysizes'
import 'picturefill'
import 'picturefill/dist/plugins/mutation/pf.mutation.min'
import React, { useState } from 'react'
import { createRoot } from 'react-dom/client'
import 'url-search-params-polyfill'
import 'whatwg-fetch'
import { initialRoute } from 'widgets-for-react'
import { getCookie, setCookie } from './components/cms/blocks/cookiebar.utils.mod'
import { getDrupalLanguage } from './components/drupal/types_and_parser/extra_types.mod'
import { routesArray } from './components/publicSite/route/utils'
import { initialPublicSiteState, PublicSiteState } from './components/publicSite/state'
import { defaultLanguage, getLangFromUrl, oldSites } from './components/publicSite/utils/history.mod'
import { publicSiteWidget } from './components/publicSite/widget'
import './styling/frontend/stylesheets/frontend.scss' // IMPORT STYLING - DO NOT REMOVE

const publicSite = async () => {
  const headers = new Headers()

  let res = await fetch(`/translations.json`, { method: 'get', credentials: 'include', headers: headers })
  let resources = await res.json()
  if (window.location.href.includes('clearcookie=true')) selectRegionNoRedirect(oldSites.get('en'))

  let cookieValue = getCookie('selectedRegion')
  if (
    cookieValue != undefined &&
    cookieValue != '' &&
    oldSites.get('en') != cookieValue &&
    document.location.href == oldSites.get('en')
  ) {
    console.log('redirecting', cookieValue)
    document.location.href = cookieValue
    return
  }

  const root = createRoot(document.getElementById('react-content'))

  // i18next wants the Drupal language, the state wants the locale. They differ on
  // every site whose language is not its own url prefix: na, na-fr, uk and au all
  // map to a language that is another site's prefix, or to none at all. Passing the
  // language here made the footer ask /api/drupal/en/api/menu_items/footer, which
  // falls back to the default site and returns the global footer menu. The header
  // never had the problem, because it reads the locale straight from the url.
  // SREFC-147.
  const locale = getLangFromUrl()
  const lng = getDrupalLanguage(locale)

  i18next.init(
    {
      lng: lng,
      fallbackLng: defaultLanguage,
      ns: ['translation', 'Common', 'GlobalProduct', 'SubsidiaryProduct', 'Property', 'Cookies'],
      resources: resources
    },
    (): void => root.render(<PublicSite initialState={initialRoute(routesArray)(initialPublicSiteState())} />)
  )
}

const selectRegionNoRedirect = (url: string): void => setCookie('selectedRegion', url, 14)

const PublicSite = ({ initialState }: { initialState: PublicSiteState }): JSX.Element => {
  const [state, setState] = useState<PublicSiteState>(initialState)
  return publicSiteWidget(state).run(setState)
}

publicSite()
